import { render, staticRenderFns } from "./AudienceCustomerDetails.vue?vue&type=template&id=d9c42026&"
import script from "./AudienceCustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./AudienceCustomerDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceCustomerDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports